import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

import { reduxForm } from 'redux-form';

import { withStyles } from 'material-ui/styles';

import validationHelper from '../../helpers/ValidationHelper';

import autotecStyle from '../../components/Styles/style';
import { inherits } from 'util';

const marginStyle = {
  width: '228px',
  height: '18px'
};
const validate = (values) => {
  const errors = validationHelper.validateRequired(['username', 'password'], values);
  return errors;
};

class UsernamePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    };
  }

  handleUsernameChange(e) {
    this.setState({ username: e.target.value.trim() });
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value.trim() });
  }

  handleKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      this.login();
    }
  }

  login = () => {
    this.props.login(this.state.username.toLowerCase().trim(), this.state.password);
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div style={{ marginTop: '52px' }}>
          <TextField
            name="username"
            value={this.state.username}
            placeholder="Username"
            style={marginStyle}
            onChange={e => this.handleUsernameChange(e)}
            onKeyPress={e => this.handleKeyPress(e)}
            InputProps={{
              classes: {
                input: classes.textFieldInput,
              },
            }}
          />
        </div>
        <br />
        <div style={{ marginTop: '37px' }}>
          <TextField
            name="password"
            type="password"
            value={this.state.password}
            placeholder="Password"
            style={marginStyle}
            onChange={e => this.handlePasswordChange(e)}
            onKeyPress={e => this.handleKeyPress(e)}
            InputProps={{
              classes: {
                input: classes.textFieldInput,
              },
            }}
          />
        </div>
        <div align="left" style={{ marginLeft: '83px', marginTop: '38px' }}>
          <Button
            onClick={e => this.props.openSupportDialog(e)}
            className={classes.linkButton}
            classes={{
              label: classes.label, // class name, e.g. `classes-nesting-label-x`
            }}
          >Forgot Username?</Button>
        </div>
        <div align="left" style={{ marginLeft: '82px', marginTop: '-26px' }}>
          <Button
            onClick={e => this.props.showForgotPasswordDialog(e)}
            className={classes.linkButton}
            classes={{
              label: classes.label, // class name, e.g. `classes-nesting-label-x`
            }}
          >Forgot Password?</Button>
        </div>
        <Button variant="raised" color="primary" className={classes.buttonStyle} onClick={() => this.login()}>Sign In</Button>
      </div>
    );
  }
}

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({
  form: 'UsernamePasswordForm',
  validate
})(UsernamePassword));


// WEBPACK FOOTER //
// ./src/components/User/UsernamePassword.js